// Module
var code = "<div class=\"alert-box\">\n  <div class=\"alert-box-container\">\n    <svg class=\"alert-box-icon\" width=\"44\" height=\"44\">\n      <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" href=\"#\"></use>\n    </svg>\n    <h3 class=\"lead\">{{ data.title }}</h3>\n    <p>{{ data.description }}</p>\n  </div>\n</div>\n";
// Exports
module.exports = code;